import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkflowOrigin, WorkflowStepType, WorkflowType } from '@warema/shared/models';
import { WorkflowStepsService } from './workflow-steps.service';
import * as WorkflowActions from '../state/workflow.actions';
import { WorkflowState } from '../state/workflow.reducers';

@Injectable({
    providedIn: 'root',
})
export class WorkflowDataInitializationService {
    private readonly _store = inject<Store<WorkflowState>>(Store);
    private readonly _workflowStepService = inject(WorkflowStepsService);

    public initWorkflowData(
        workflowType: WorkflowType,
        origin: WorkflowOrigin,
        jumpedFromCompanySearch: boolean,
        desiredInitialStep?: WorkflowStepType,
    ): void {
        const workflowSteps = this._workflowStepService.getSteps(workflowType, origin, jumpedFromCompanySearch);
        const workflowSelectedStep = this._workflowStepService.getInitialStepTypeForWorkflow(
            workflowSteps,
            origin,
            workflowType,
            desiredInitialStep,
            jumpedFromCompanySearch,
        );

        this._store.dispatch(
            WorkflowActions.InitializeWorkflow({
                steps: workflowSteps,
                stepType: workflowSelectedStep,
                workflowOrigin: origin,
                workflowType,
            }),
        );
    }
}
